import cn from 'classnames';
import React, { Children, memo } from 'react';
import type { FC, PropsWithChildren } from 'react';
import { useNamedContainersWithChildren } from '@alfa-bank/site-named-container/utils';

import type { TNotification } from './models';

export const Notification: FC<PropsWithChildren<TNotification>> = memo(props => {
    const {
        NotificationBase,
        Stack,
        autoCloseDelay,
        badge,
        children,
        className,
        componentRef,
        config,
        // TODO после тех. релиза можно удалить пропс, пока оставлен в технических для обратной совместимости
        theme,
        colors = 'default',
        hasCloser = true,
        hideNotification,
        offset = config.offset,
        styles,
        title,
        visible,
        position,
        usePortal = false,
        zIndex = 1000,
        block,
    } = props;

    const {
        actionButton,
        children: otherChildren,
        leftAddons,
    } = useNamedContainersWithChildren(children);

    const childrenArray = Children.toArray(otherChildren);

    return (
        <Stack value={zIndex}>
            {zIndx => (
                <NotificationBase
                    ref={componentRef}
                    actionButton={actionButton}
                    actionSectionClassName={cn(styles.external, styles.actionSection, {
                        [styles.actionSectionWithRightPadding]: hasCloser,
                    })}
                    autoCloseDelay={autoCloseDelay}
                    badge={badge}
                    block={block}
                    className={cn(styles.external, styles.notificationBase, className, {
                        [styles.notificationBaseWithMaxWidth]: !block,
                    })}
                    closerClassName={cn(styles.external, styles.closerButton)}
                    colors={theme || colors}
                    contentClassName={cn(styles.external, {
                        [styles.contentClass]: block,
                    })}
                    hasCloser={hasCloser}
                    leftAddons={leftAddons}
                    offset={offset}
                    onClose={hideNotification}
                    onCloseTimeout={hideNotification}
                    position={position}
                    title={title}
                    titleClassName={cn(styles.external, styles.title)}
                    usePortal={usePortal}
                    visible={visible}
                    zIndex={zIndx}
                >
                    {childrenArray}
                </NotificationBase>
            )}
        </Stack>
    );
});
